import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ProjectsTable from '@/components/ProjectsTable.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_ui_panel = _resolveComponent("ui-panel")!

  return (_openBlock(), _createBlock(_component_ui_panel, { header: "Projects" }, {
    default: _withCtx(() => [
      _createVNode(ProjectsTable)
    ]),
    _: 1
  }))
}
}

})